<script setup>
import { ref, computed } from 'vue'
import SearchInput from '@/components/shared/SearchInput.vue'

const props = defineProps({
  modelValue: {
    type: Number,
    default: null,
  },
  items: {
    type: Array,
    default: () => [],
  },
  icon: {
    type: String,
    required: true,
  },
  allowAll: {
    type: Boolean,
    default: false,
  },
  searchable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const search = ref('')

const filteredItems = computed(() => {
  const query = search.value.trim().toLowerCase()
  return query
    ? props.items.filter(item => item.name.toLowerCase().includes(query))
    : props.items
})

const selectedItem = computed(() => props.items.find(item => item.id === props.modelValue) ?? null)

const onSelect = (id) => {
  search.value = ''
  emit('update:modelValue', id)
}
</script>
<template>
  <q-item
    v-ripple
    dense
    clickable
  >
    <q-item-section avatar style="min-width: 1.75rem">
      <q-icon :name="icon" color="primary" size="sm" />
    </q-item-section>
    <q-item-section>
      <q-item-label class="text-weight-medium text-caption ellipsis">
        {{ selectedItem?.name ?? $t('common.all') }}
      </q-item-label>
    </q-item-section>
    <q-item-section side style="padding-left: .25rem">
      <q-icon name="mdi-unfold-more-horizontal" color="grey-5" size="xs" />
    </q-item-section>
    <q-menu
      transition-show="jump-down"
      transition-hide="jump-up"
      @hide="search = ''"
    >
      <q-card>
        <q-card-section v-if="searchable" class="q-pt-sm q-pb-xs q-px-sm">
          <search-input v-model="search" @click.stop @clear="search = ''" />
        </q-card-section>
        <q-separator v-if="searchable" />
        <div style="max-height: 40vh; min-width: 12.5rem; max-width: 80vw; overflow-y: auto">
          <q-list>
            <q-item
              v-if="allowAll && !search"
              v-close-popup
              clickable
              class="q-pa-sm"
              @click="onSelect(null)"
            >
              <q-item-section side class="q-pr-sm">
                <q-checkbox
                  :model-value="modelValue === null"
                  size="sm"
                  @click.stop
                  @update:model-value="onSelect(null)"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label class="q-pr-sm">{{ $t('common.all') }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              v-for="item in filteredItems"
              :key="item.id"
              v-close-popup
              clickable
              class="q-pa-sm"
              @click="onSelect(item.id)"
            >
              <q-item-section side class="q-pr-sm">
                <q-checkbox
                  :model-value="modelValue === item.id"
                  size="sm"
                  @click.stop
                  @update:model-value="onSelect(item.id)"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label class="q-pr-sm">{{ item.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
      </q-card>
    </q-menu>
  </q-item>
</template>
